import React from 'react';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { Close } from '@material-ui/icons';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import _e from 'common/localeUtil';
import GMButton from '../button/GMButton';

const useStyles = makeStyles((theme) => ({
	dialogTitleLabelStyle: {
		flex: 1,
		display: 'flex',
		'& .MuiTypography-root': {
			lineHeight: '250%',
		},
	},
	dialogTitleRoot: {
		display: 'flex',
		paddingTop: theme.spacing(2),
		flexDirection: 'row',
		flex: 1,
		justifyContent: 'space-between',
		paddingBottom: `${theme.spacing(1)}px !important`,
	},
	dialogContent: {
		// paddingBottom: 0,
		'&.shade': {
			backgroundColor: '#f2f2f2',
		},
		'&.noPadding': {
			paddingLeft: 0,
			paddingRight: 0,
		},
		paddingTop: theme.spacing(2),
	},
	dialog: ({ minWidth }) => ({
		'& .MuiDialog-paper': {
			minWidth,
		},
	}),
}));

const GenericDialog = ({
	open,
	loading,
	disableContentPadding,
	shadedContent,
	handleClose,
	title,
	subtitle,
	content,
	confirmButtonVariant,
	confirmAction,
	confirmButtonColor,
	showTitleDivider,
	confirmLabel,
	hideConfirmButton,
	renderActions,
	fullWidth,
	minWidth,
	...otherProps
}) => {
	const classes = useStyles({ minWidth });
	return (
		<Dialog
			{...otherProps}
			fullWidth={window.innerWidth >= 768 ? fullWidth : false}
			onClose={handleClose}
			aria-labelledby="simple-dialog-title"
			open={open}
			className={`dialog ${classes.dialog}`}
		>
			<DialogTitle disableTypography classes={{ root: classes.dialogTitleRoot }}>
				<Box
					display="flex"
					flex={1}
					justifyContent="space-between"
					alignItems="flex-start"
					pb={1}
				>
					<Box display="flex" flex={1} flexDirection="column">
						<div className={classes.dialogTitleLabelStyle}>
							<Typography variant="h6">{title}</Typography>
						</div>
						{subtitle && (
							<div className={classes.dialogSubtitleStyle}>
								<Typography variant="body1">{subtitle}</Typography>
							</div>
						)}
					</Box>
					{handleClose && (
						<IconButton onClick={handleClose} className="cancel-button">
							<Close />
						</IconButton>
					)}
				</Box>
			</DialogTitle>
			{showTitleDivider && <Divider />}
			<DialogContent
				className={`${classes.dialogContent} ${disableContentPadding ? 'noPadding' : ''} ${
					shadedContent ? 'shade' : ''
				}`}
			>
				{content}
			</DialogContent>
			{!hideConfirmButton && (
				<DialogActions>
					{!renderActions ? (
						<div style={{ textAlign: 'right' }}>
							<GMButton
								id={`action-${title}`}
								variant={confirmButtonVariant}
								title={confirmLabel || _e('ok')}
								loading={loading}
								color={confirmButtonColor}
								onClick={confirmAction || handleClose}
							/>
						</div>
					) : (
						renderActions()
					)}
				</DialogActions>
			)}
		</Dialog>
	);
};

GenericDialog.propTypes = {
	open: PropTypes.bool,
	loading: PropTypes.bool,
	confirmLabel: PropTypes.string,
	handleClose: PropTypes.func,
	content: PropTypes.object,
	title: PropTypes.string,
	subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	hideConfirmButton: PropTypes.bool,
	confirmButtonColor: PropTypes.string,
	confirmButtonVariant: PropTypes.string,
	showTitleDivider: PropTypes.bool,
	confirmAction: PropTypes.func,
	shadedContent: PropTypes.bool,
	disableContentPadding: PropTypes.bool,
	renderActions: PropTypes.func,
	fullWidth: PropTypes.bool,
	minWidth: PropTypes.number,
};

GenericDialog.defaultProps = {
	confirmLabel: _e('ok'),
	confirmButtonColor: 'primary',
	confirmButtonVariant: 'contained',
	showTitleDivider: false,
	minWidth: 600,
};

export default GenericDialog;
